export class ErrorCodes {
    public static ServerError = 'application.errors.server-error';
    public static NotEnoughPermissions = 'application.errors.not-enough-permissions';
    public static WebsocketConnectionError = 'application.errors.websocket-connection-error';
    public static TooManyFailedAuthorizationAttempts = 'application.errors.too-many-failed-authorization-attempts';
}
